<template>
	<div class="row">
		<div class="col">
		    <form @submit.prevent="checkForm" class="mb-4">
		        <div class="row">
		            <div class="col-12" v-if="form_message !== ''">
		                <ErrorAlert :messageI18n="form_message" />
		            </div>
		        </div>
		        
		        <div class="row">
				<div class="col-12 col-sm-6">
					<div class="form-group">
						<label for="payment_method">{{ $t('payment.payment_method') }} *</label>
						<e-select
							v-show="show_payment_methods"
							id="payment_method"
							:class="{ 'is-invalid': errors && errors.indexOf('Method') > -1 }"
							v-model="payment.payment_method"
							:options="payment_methods"
							:loading="loading_method"
							track-by="paymentmethod_id"
							label="translated_option"
							:allow-empty="false"
						/>
					</div>
				</div>

					<div class="col-12 col-sm-6">
						<div class="form-group">
							<label for="payment_date">{{ $t('payment.payment_date') }} *</label>
							<e-datepicker v-model="payment.payment_date"></e-datepicker>
						</div>
					</div>
				</div>

				<div class="row" v-if="display_bankcheck">
					<div class="col-12 col-sm-6">
						<div class="form-group">
							<label for="payment_bank">{{ $t('payment.payment_bank') }}</label>
							<e-select
								id="payment_bank"
								v-model="payment.payment_bank"
								:options="payment_banks"
								track-by="paymentbank_label"
								label="paymentbank_label"
								:allow-empty="false"
							/>
						</div>
					</div>

					<div class="col-12 col-sm-6">
						<div class="form-group">
							<label for="payment_bankcheck">{{ $t('payment.payment_bankcheck') }}</label>
							<input id="payment_bankcheck" class="form-control" v-model="payment.payment_bankcheck" :placeholder="this.getTrad('payment.payment_bankcheck_placeholder')">
						</div>
					</div>
				</div>

				<div v-if="diplay_message_cc" class="row">
					<div class="col">
						<b-alert show variant="warning">
							{{ getTrad('payment.montant_sup_cc', {x:payment.payment_method.balance}) }}<br>
							<a href="#" @click.prevent="appliqueSoldeCC">{{ $t('payment.appliquer_solde_cc') }}</a>
						</b-alert>
					</div>
				</div>

				<div class="row">
					<div class="col">
						<div class="form-group">
							<label for="payment_amount">{{ $t('payment.payment_amount') }} *</label>
							<!-- La devise est apposée au champ : un règlement se saisit dans la devise de tenue,
								 alors que la facture qu'il éteint peut être libellée dans une autre. Sans ce
								 repère, rien à l'écran ne distingue 18,70 € de 18,70 $. -->
							<div class="input-group">
								<input id="payment_amount" class="form-control" v-model="payment.payment_amount" :placeholder="this.getTrad('payment.payment_amount_placeholder')" :class="{ 'is-invalid': errors && errors.indexOf('Amount') > -1 }">
								<div class="input-group-append">
									<span class="input-group-text">{{ ledger_currency_symbol }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12">
						<b-alert v-if="error_amount_avoir" variant="danger" show>
                            {{ $t('payment.positive_amount_avoir') }}
                        </b-alert>
						<b-alert v-if="error_avoir_negativ" variant="danger" show>
                            {{ $t('payment.to_negative_amount') }}
                        </b-alert>
					</div>
					<div class="col-12" v-if="settlement_gap">
						<b-form-checkbox v-model="settle_exchange_gap">
							{{ $t('invoice.bank_flow_settle_exchange_gap', { gap: settlement_gap }) }}
						</b-form-checkbox>
					</div>
				</div>

				<div class="row">
					<div class="col">
						<div class="form-group">
							<label for="payment_comment">{{ $t('payment.payment_comment') }}</label>
							<textarea id="payment_comment" class="form-control" v-model="payment.payment_comment" :placeholder="this.getTrad('payment.payment_comment_placeholder')" rows="2"></textarea>
						</div>
					</div>
				</div>

				<div class="row" v-if="invoices_suppliers.length > 0">
					<div class="col">
						<p>
							<span v-if="invoices_suppliers.length == 1">{{ $t('payment.add_payment_for_invoice') }} :</span>
							<span v-else>{{ $t('payment.add_payment_for_invoice_multiple') }} :</span>
							<ul>
								<li v-for="invoice in invoices_suppliers" :key="invoice.suppliersocr_num">{{ invoice.suppliersocr_num }}</li>
							</ul>
						</p>
					</div>
				</div>
	        	<!-- Le bouton disparaît dès qu'une des deux alertes s'affiche. Le OU d'origine ne le
	        	     masquait que si les deux tombaient ensemble, ce qu'elles ne font jamais : leurs
	        	     conditions s'excluent sur le signe du montant. -->
	        	<div v-if="!error_amount_avoir && !error_avoir_negativ" class="row">
		            <div class="text-center mt-3 col-12">
	            		<b-button variant="primary" @click.prevent="addPayment"><font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'plus']" /> {{ $t("action.ajouter") }}</b-button>
		            </div>
		        </div>
		    </form>
		</div>
		<!-- La colonne est celle du composant : sans mouvement à proposer, il ne rend rien, et le
		     formulaire reprend toute la largeur au lieu d'en céder la moitié à un cadre vide. -->
		<BankFlowSuggestion
			v-if="hasBridgeConnect && accounting_plan"
			class="col-6"
			:accountingplan_id="accounting_plan.accountingplan_id"
			:amount="suggest_amount"
			:date="invoices_suppliers[0].suppliersocr_date"
			:supplier="true"
			:invoices_ids="invoices_suppliers_ids"
			@submit="goNext"
		/>
	</div>
</template>

<script type="text/javascript">
	import TableAction from "@/mixins/TableAction.js"
	import Navigation from "@/mixins/Navigation.js"
	import Config from "@/mixins/Config.js"
	import Payment from "@/mixins/Payment.js"
	import Accounting from "@/mixins/Accounting.js"
	import _cloneDeep from 'lodash/cloneDeep'
	import Shutter from "@/mixins/Shutter.js"


	export default {
		name: "InvoiceSupplierAddPayment",
		mixins: [Config, TableAction, Navigation, Payment, Accounting, Shutter],
		props: {
			invoices_suppliers: {
				type: Array,
				default: () => {
					[]
				}
			}
		},
		data () {
			return {
				form_message: '',
				payment_methods: this.getConfig('payment_method'),
				payment_methods_save: this.getConfig('payment_method'),
				payment_banks: this.getConfig('payment_bank'),
				loading_method: false,
				display_bankcheck: false,
				diplay_message_cc: false,
				payment: {
					payment_method: null,
					payment_date: new Date(),
					payment_bank: null,
					payment_amount: null,
				},
				accounting_plan: null,
				isLoadingAccountingPlan: false,
				errors: [],
				current_account: null,
				unpaid: [],
				table_busy: true,
				error_amount_avoir: false,
				error_avoir_negativ: false,
				show_payment_methods: true,
				processing: false,
				tiers_id: null,
				suggest_amount: 0,
				invoices_suppliers_ids: [],
				settlement_gap: null,
				settle_exchange_gap: false
			}
		},
		mounted() {
			this.init_component()
		},
		created () {
		},
		methods: {
			async init_component() {
				this.payment.payment_amount = this.invoice_balances

				this.suggest_amount = this.payment.payment_amount
				this.invoices_suppliers_ids = this.invoices_suppliers.map(invoice => invoice.suppliersocr_id)

				// Formatage payment banks
				this.payment_banks = this.payment_banks.map((bank) => {
					bank.paymentbank_label = bank.paymentbank_label + ' - ' + bank.paymentbank_code
					return bank
				})

				this.tiers_id = this.invoices_suppliers[0].suppliersocr_tiers
				this.accounting_plan = await this.loadAccountingPlanByEntity(this.invoices_suppliers[0].suppliersocr_entity)
				await this.currentAccount(true)
			},
			async checkForm() {

			},

			/**
			 * Recalcule l'écart entre ce que le règlement apporte et ce que la facture doit, et décide
			 * s'il mérite d'être soumis à l'utilisateur.
			 *
			 * La question n'a de sens que sur une facture en devise réglée seule : ailleurs un écart est
			 * un paiement partiel, pas un cours qui a bougé, et à plusieurs factures rien ne dirait à
			 * laquelle il revient. Le seuil reprend celui du serveur, qui refuse au-delà.
			 *
			 * Les montants de cet écran sont en euros — le serveur les multiplie par cent — alors que la
			 * tolérance se compte en centimes : la conversion est faite ici, une fois.
			 */
			async refreshSettlementGap() {
				if(this.invoices_suppliers.length !== 1) {
					this.settlement_gap = null
					this.settle_exchange_gap = false
					return
				}

				const invoice = this.invoices_suppliers[0]
				const balance_cents = Math.round(invoice.suppliersocr_balance * 100)
				const gap = Math.round(this.parseAmount(this.payment.payment_amount) * 100) - balance_cents
				const tolerance = this.settlementTolerance(balance_cents, invoice.suppliersocr_balance_src !== null)

				if(!gap || Math.abs(gap) > tolerance) {
					this.settlement_gap = null
					this.settle_exchange_gap = false
					return
				}

				this.settlement_gap = await this.priceFormat(gap / 100, invoice.suppliersocr_ledger_currency, true)
			},

			async addPayment(){

				this.errors = []
				this.processing = true

				if(this.payment.payment_amount == null)
				{
					this.errors.push("Amount")
				}

				if(!Date.parse(this.payment.payment_date))
				{
					this.errors.push("Date")
				}

				if(this.payment.payment_method == null)
				{
					this.errors.push("Method")
				}

				if(this.invoices_suppliers.length == 0 && this.accounting_plan == null)
				{
					this.errors.push("Accounting Plan")
				}

				if(this.errors.length > 0)
				{
					this.processing = false
					return false
				}


				let result = null
				if(this.accounting_plan != null)
				{
					this.payment.accounting_plan = this.accounting_plan.accountingplan_id
				}
				this.payment.invoice_ids = this.invoices_suppliers.map(invoice => invoice.suppliersocr_id)
				this.payment.tiers_id = this.$sync.replaceWithReplicated('tiers', this.tiers_id)

				// Facture que l'utilisateur déclare éteinte malgré l'écart : le serveur en fait une perte
				// ou un gain de change plutôt qu'un versement au compte courant du fournisseur.
				this.payment.settled = this.settle_exchange_gap ? [this.invoices_suppliers[0].suppliersocr_id] : []

				const temp_send = _cloneDeep(this.payment)
				temp_send.payment_method = this.payment.payment_method.paymentmethod_id
				temp_send.payment_bank   = this.payment.payment_bank ? this.payment.payment_bank.paymentbank_id : null
				result = await this.createPaymentSupplier(temp_send)
				
				if(result) {
					this.processing = false
					this.goNext()
				}
				else {
					this.processing = false
				}
				
			},

			goNext() {
				this.successToast()
				this.ok()
				this.shutterPanel().close('invoice-supplier-payment')
			},

			async currentAccount(){
				this.loading_method = true
				this.current_account = await this.getCurrentAccountSupplier(this.tiers_id)
				
				await this.displayCurrentAccount()

				// Formatage payment methods
				this.payment_methods.map((option) => {
					let translated_option = this.getTrad('payment.payment_method_labels.' + option.paymentmethod_code.toLowerCase())
					if (option.paymentmethod_code == 'CC') {
						const regExp = /\(([^)]+)\)/;
						const matches = regExp.exec(option.paymentmethod_label);
						if(matches && matches[0]){
							translated_option += ' ' + matches[0]
						}
					}
					option.translated_option = translated_option
					return option
				})
				this.show_payment_methods = false
				this.$nextTick(() => {
					this.show_payment_methods = true
				})
				this.loading_method = false
			},

			async displayCurrentAccount(){
				const index_current_account = this.payment_methods.findIndex(elem => elem.paymentmethod_code == "CC")
				this.payment_methods[index_current_account].paymentmethod_label = this.payment_methods_save[index_current_account].paymentmethod_label + " (0)"
				this.payment_methods[index_current_account].balance = 0

				if(this.current_account && Object.keys(this.current_account).length > 0) {
					if(this.accounting_plan) {
						if(this.current_account[this.accounting_plan.accountingplan_label]) {
							const balance = this.current_account[this.accounting_plan.accountingplan_label].balance ?? 0
							const currency = this.current_account[this.accounting_plan.accountingplan_label].currency ?? 'EUR'
							this.payment_methods[index_current_account].paymentmethod_label = this.payment_methods_save[index_current_account].paymentmethod_label + " (" + (balance / 100) + " " + currency + ")"
							this.payment_methods[index_current_account].balance = balance / 100
						}
					}
					else {
						if(this.current_account[this.invoice_accountingplans[0]]) {
							const balance = this.current_account[this.invoice_accountingplans[0]].balance ?? 0
							const currency = this.current_account[this.invoice_accountingplans[0]].currency ?? 'EUR'
							this.payment_methods[index_current_account].paymentmethod_label = this.payment_methods_save[index_current_account].paymentmethod_label + " (" + (balance / 100) + " " + currency + ")"
							this.payment_methods[index_current_account].balance = balance / 100
						}
					}
				}
			},

			async removeCurrentAccountMethod(){
				const index_current_account = this.payment_methods.findIndex(elem => elem.paymentmethod_code == "CC")
				this.payment_methods.splice(index_current_account, 1);
			},
			checkCC() {
				if(this.payment.payment_method.balance < parseFloat(this.payment.payment_amount))
				{
					this.diplay_message_cc = true
				}
			},

			appliqueSoldeCC() {
				this.payment.payment_amount = this.payment.payment_method.balance
			}
		},
		computed: {
            hasBridgeConnect() {
                return this.$store.state.userAccess.hasBridgeConnect
            },

			/**
			 * Symbole de la devise dans laquelle le règlement est saisi, qui est celle de la tenue de la
			 * comptabilité et non celle du fournisseur.
			 */
			ledger_currency_symbol() {
				const invoice = this.invoices_suppliers[0]

				return this.currencySymbol((invoice && invoice.suppliersocr_ledger_currency) || 'EUR')
			},

			/**
			 * Ce que la sélection doit au total, négatif quand les avoirs l'emportent. C'est ce même total
			 * qui est proposé comme montant du règlement.
			 *
			 * Les deux alertes qui l'emploient ne s'affichaient jamais : elles lisaient une propriété que
			 * ce composant n'avait pas — seul son équivalent côté ventes la reçoit en propriété.
			 */
			invoice_balances() {
				return this.invoices_suppliers.reduce((sum, invoice) => sum + invoice.suppliersocr_balance, 0)
			},
		},
		watch:{
			'payment.payment_method'(val) {
				this.display_bankcheck = false
				this.diplay_message_cc = false
				
				if(val.paymentmethod_code == "CH") {
					this.display_bankcheck = true
				}
				else if(val.paymentmethod_code == "CC") {
					this.checkCC()
				}
			},
			'payment.payment_amount'(val) {
				this.error_amount_avoir = val > 0 && this.invoice_balances < 0
				this.error_avoir_negativ = val < 0 && this.invoice_balances < 0 && val < this.invoice_balances
				this.refreshSettlementGap()
			}
		},
		components: {
			ErrorAlert: () => import('GroomyRoot/components/Alert/ErrorAlert'),
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
			BankFlowSuggestion: () => import('@/components/Invoice/BankFlowSuggestion')
		}
	}
</script>